import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LoginModal from "./login/LoginModal";
import appMockup from "../../assets/app.png";

const scrollToId = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export default function Index() {
  // ----- Datos
  const banners = useMemo(
    () => [
      "/assets/banner/banner1.png",
      "/assets/banner/banner2.png",
      "/assets/banner/banner3.png",
      "/assets/banner/banner4.png",
      "/assets/banner/banner5.png",
    ],
    []
  );

  const productos = useMemo(
    () => Array.from({ length: 12 }).map((_, i) => `/assets/productos/${i + 1}.png`),
    []
  );

  // ----- Estado de UI
  const [mobileOpen, setMobileOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  // Formulario contacto rápido
  const [form, setForm] = useState({ nombre: "", correo: "", mensaje: "" });

  // Carrusel
  const trackRef = useRef(null);
  const [slide, setSlide] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    startAuto();
    return stopAuto;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banners.length]);

  const startAuto = () => {
    stopAuto();
    intervalRef.current = setInterval(() => {
      setSlide((s) => (s + 1) % banners.length);
    }, 5000);
  };
  const stopAuto = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    if (!trackRef.current) return;
    trackRef.current.style.transform = `translateX(-${slide * 100}%)`;
  }, [slide]);

  useEffect(() => {
    if (!aboutOpen) return;
    const onKey = (e) => e.key === "Escape" && setAboutOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [aboutOpen]);

  // Form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, correo, mensaje } = form;
    const text = `Hola Promequi,%0AQuiero más información.%0A%0ANombre: ${encodeURIComponent(
      nombre
    )}%0ACorreo: ${encodeURIComponent(correo)}%0AMensaje: ${encodeURIComponent(mensaje)}`;
    window.open(`https://wa.me/50259786302?text=${text}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-white text-slate-800">
      {/* Estilos locales */}
      <style>{`
        :root{
          --brand:#244A9B;
          --brand-soft:#9EC2FF;
          --ink:#0F1D43;
        }
        .soft{box-shadow:0 12px 30px rgba(15,29,67,.06),0 6px 14px rgba(15,29,67,.05)}
        .btn{display:inline-flex;align-items:center;justify-content:center;border-radius:0.75rem;padding:.75rem 1.25rem;font-weight:600;transition:.15s transform;}
        .btn:active{transform:scale(.99)}
        .btn-brand{background:var(--brand);color:#fff}
        .btn-brand:hover{filter:brightness(.93)}
        .btn-light{background:#fff;color:#334155;border:1px solid #e2e8f0}
        .nav-link{font-size:.9rem;font-weight:700;letter-spacing:.02em;color:#475569}
        .nav-link:hover{color:#0f172a}
        @keyframes prod-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .animate-prod-scroll { animation: prod-scroll 25s linear infinite; }
        @media print { body { display: none !important; } }
      `}</style>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-24 flex items-center justify-between">
            {/* Logo → Home */}
            <Link to="/" className="flex items-center gap-3" aria-label="Inicio Promequi">
              <img src="/assets/logo.png" alt="Logo Promequi" className="h-24 w-auto" />
            </Link>

            {/* Nav desktop */}
            <nav className="hidden md:flex items-center gap-6">
              <button
                type="button"
                className="nav-link cursor-pointer"
                onClick={() => {
                  setAboutOpen(true);
                  setMobileOpen(false);
                }}
              >
                QUIÉNES SOMOS
              </button>

              <button type="button" className="nav-link" onClick={() => scrollToId("productos")}>
                PRODUCTOS
              </button>

              <Link className="nav-link" to="/catalogo">
                TIENDA EN LÍNEA
              </Link>


              <Link className="nav-link" to="/contacto">
                CONTACTO
              </Link>

 
            </nav>

            {/* Burger */}
            <div className="flex items-center gap-3">
              <button
                onClick={() => setMobileOpen((v) => !v)}
                className="md:hidden p-2 rounded-lg border border-slate-200"
                aria-label="Abrir menú"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>

          {/* Nav mobile */}
          {mobileOpen && (
            <div className="md:hidden pb-4">
              <div className="flex flex-col gap-3 text-sm">
                <button
                  className="py-2 text-left"
                  onClick={() => {
                    setAboutOpen(true);
                    setMobileOpen(false);
                  }}
                >
                  QUIÉNES SOMOS
                </button>
                <button
                  className="py-2 text-left"
                  onClick={() => {
                    scrollToId("productos");
                    setMobileOpen(false);
                  }}
                >
                  PRODUCTOS
                </button>
                <Link to="/catalogo" className="py-2" onClick={() => setMobileOpen(false)}>
                  TIENDA EN LÍNEA
                </Link>
                <Link to="/contacto" className="py-2" onClick={() => setMobileOpen(false)}>
                  CONTACTO
                </Link>
                <button
                  className="py-2 text-left font-bold px-4 rounded-xl bg-sky-500 text-white hover:bg-sky-600 transition"
                  onClick={() => {
                    setLoginOpen(true);
                    setMobileOpen(false);
                  }}
                >
                  INICIA SESIÓN
                </button>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero (carrusel) */}
      <section id="home" className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
          <div
            className="relative overflow-hidden rounded-3xl soft"
            onMouseEnter={stopAuto}
            onMouseLeave={startAuto}
          >
            <div ref={trackRef} className="flex transition-transform duration-700">
              {banners.map((src, idx) => (
                <img key={idx} src={src} alt={`Banner ${idx + 1}`} className="w-full h-auto shrink-0" />
              ))}
            </div>

            {/* Dots */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
              {banners.map((_, idx) => {
                const active = idx === slide;
                return (
                  <button
                    key={idx}
                    aria-label={`Ir al slide ${idx + 1}`}
                    onClick={() => {
                      stopAuto();
                      setSlide(idx);
                      startAuto();
                    }}
                    className={`h-2.5 w-2.5 rounded-full transition transform ${
                      active ? "bg-white/80 scale-125" : "bg-white/50"
                    }`}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Visión / Misión / Valores */}
      <section id="quienes" className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 rounded-2xl bg-slate-50 border border-slate-200">
              <h3 className="text-xl font-extrabold" style={{ color: "var(--ink)" }}>
                Visión
              </h3>
              <p className="mt-2 text-slate-600">
                Ser reconocidos a nivel nacional como líderes en el sector de la salud y rehabilitación, destacando por
                nuestra innovación, atención personalizada y compromiso con la mejora continua. Aspiramos a crear
                relaciones duraderas con nuestros clientes, anticipándonos a sus necesidades y ofreciendo un servicio
                ágil, empático y de excelencia que transforme vidas y genere confianza a largo plazo.
              </p>
            </div>
            <div className="p-6 rounded-2xl bg-slate-50 border border-slate-200">
              <h3 className="text-xl font-extrabold" style={{ color: "var(--ink)" }}>
                Misión
              </h3>
              <p className="mt-2 text-slate-600">
                Brindar soluciones de alta calidad en productos para la rehabilitación de las personas, comprometidos
                con un servicio excepcional, accesible y humano. Nos esforzamos por ser una empresa confiable, eficiente
                y centrada en la satisfacción plena de nuestros clientes, contribuyendo activamente al bienestar y la
                salud integral de cada persona a la que servimos.
              </p>
            </div>
            <div className="p-6 rounded-2xl bg-slate-50 border border-slate-200">
              <h3 className="text-xl font-extrabold" style={{ color: "var(--ink)" }}>
                Nuestros Valores
              </h3>
              <p className="mt-2 text-slate-600">
                <strong>1. Compromiso con la Salud.</strong> Cada producto que entregamos puede salvar una vida. Este
                valor es esencial porque Promequi no solo distribuye insumos, sino que forma parte del sistema de
                salud. El compromiso con la salud es el corazón de la empresa.
                <br />
                <br />
                <strong>2. Integridad Familiar.</strong> Confiabilidad construida a lo largo de generaciones. La esencia
                familiar de Promequi le ha permitido operar con ética, responsabilidad y relaciones sólidas. En un
                sector tan delicado, la integridad no es negociable.
                <br />
                <br />
                <strong>3. Excelencia Sostenida.</strong> 35 años creciendo con calidad, eficiencia e innovación. Este
                valor destaca la constancia y evolución de la empresa. No solo ha permanecido, sino que ha sabido
                adaptarse, mantener altos estándares y consolidar liderazgo en el mercado.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Productos */}
      <section id="productos" className="py-12" style={{ background: "var(--brand-soft)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-center text-2xl sm:text-3xl font-extrabold" style={{ color: "var(--ink)" }}>
            Productos
          </h2>

          <div className="mt-8">
            <div className="overflow-hidden p-4">
              {/* Pista duplicada para loop infinito */}
              <div className="flex items-center gap-4 w-max animate-prod-scroll">
                {productos.map((src, i) => (
                  <img
                    key={`a-${i}`}
                    src={src}
                    alt={`Producto ${i + 1}`}
                    className="w-[200px] h-[200px] object-cover rounded-xl border bg-white"
                  />
                ))}
                {productos.map((src, i) => (
                  <img
                    key={`b-${i}`}
                    src={src}
                    alt={`Producto ${i + 1}`}
                    className="w-[200px] h-[200px] object-cover rounded-xl border bg-white"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nuestros Proveedores */}
      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-center text-2xl sm:text-3xl font-extrabold tracking-wider"
            style={{ color: "var(--ink)" }}
          >
            Nuestros Proveedores
          </h2>
          <div className="mt-8">
            <img
              src="/assets/proveedores.png"
              alt="Nuestros Proveedores"
              className="block w-full h-auto rounded-2xl soft"
            />
          </div>
        </div>
      </section>

      {/* App + Contacto rápido */}
      <section className="py-12" style={{ background: "var(--brand-soft)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            {/* App */}
            <div className="flex items-center gap-6">
              <div className="hidden sm:block w-80 aspect-[9/19] rounded-3xl overflow-hidden">
                <div className="h-full w-full grid place-items-center">
                  <img src={appMockup} className="w-[250px]" alt="App Promequi" loading="lazy" />
                </div>
              </div>
              <div>
                <h3 className="text-3xl font-extrabold" style={{ color: "var(--ink)" }}>
                  App móvil
                </h3>
                <p className="mt-1 text-slate-700">Disponible para iOS / Android</p>
                <div className="mt-4 flex flex-wrap gap-3">
                  <h4 className="w-full">Visita nuestras redes sociales para estar pendiente del lanzamiento</h4>
                  <div className="flex gap-4 mt-2">
                    <a
                      href="https://www.facebook.com/PromequiGt"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook Promequi"
                      className="inline-flex items-center justify-center h-12 w-12"
                    >
                      <img src="/assets/facebook.png" alt="Facebook" className="w-24" />
                    </a>

                    <a
                      href="https://www.instagram.com/promequi"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram Promequi"
                      className="inline-flex items-center justify-center h-12 w-12"
                    >
                      <img src="/assets/instagram.png" alt="Instagram" className="w-24" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contacto */}
            <div id="contacto" className="bg-white rounded-2xl p-6 soft border border-slate-100">
              <h3 className="text-xl font-extrabold" style={{ color: "var(--ink)" }}>
                Contáctanos
              </h3>
              <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
                <div>
                  <label className="text-sm font-medium text-slate-700">Nombre</label>
                  <input
                    type="text"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                    required
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-slate-700">Correo</label>
                  <input
                    type="email"
                    name="correo"
                    value={form.correo}
                    onChange={handleChange}
                    className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                    required
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-slate-700">Mensaje</label>
                  <textarea
                    name="mensaje"
                    rows="4"
                    value={form.mensaje}
                    onChange={handleChange}
                    className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-brand w-full">
                  Enviar
                </button>
                <p className="text-xs text-slate-500">Al enviar, se abrirá WhatsApp con tu mensaje.</p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center divide-y md:divide-y-0 md:divide-x divide-slate-300">
            {/* Columna izquierda */}
            <div className="w-full md:w-auto text-center px-0 md:px-8 pb-6 md:pb-0">
              <div className="font-extrabold tracking-wide text-slate-800">PROMEQUI</div>
              <div className="mt-2 text-m text-slate-600">
                2 Calle 16-53, Zona 4 Mixco <br />
                Col. Valle Del Sol <br />
                Teléfono:{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224372562">
                  2437-2562
                </a>{" "}
                /{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224372503">
                  2437-2503
                </a>{" "}
                /{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224341904">
                  2434-1904
                </a>{" "}
                <br />
                Correo: <a href="mailto:info@promequi.com.gt">info@promequi.com.gt</a> <br />
                Horario de atención: 09:00 am a 02:00 pm
              </div>
            </div>

            {/* Columna derecha (WhatsApp) */}
            <div className="w-full md:w-auto text-center px-0 md:px-8 pt-6 md:pt-0">
              <a
                href="https://wa.me/50259786302?text=Hola%20Promequi%2C%20quisiera%20informaci%C3%B3n"
                className="inline-flex"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Escríbenos por WhatsApp"
                title="WhatsApp"
              >
                <img src="/assets/whatsapp.png" alt="WhatsApp" className="h-16 w-16 mx-auto" />
                <p className="pl-8 flex items-center justify-center">¿CONSULTAS? 👈🏼</p>
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal de Login */}
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />

      {/* Modal "Quiénes somos" */}
      {aboutOpen && (
        <div role="dialog" aria-modal="true" aria-labelledby="aboutTitle" className="fixed inset-0 z-[60]">
          {/* Fondo */}
          <button
            onClick={() => setAboutOpen(false)}
            className="absolute inset-0 bg-slate-900/60"
            aria-label="Cerrar modal"
          />
          {/* Contenedor */}
          <div className="relative mx-auto max-w-3xl w-[92%] sm:w-[85%] bg-white rounded-2xl soft p-6 sm:p-8 mt-16 md:mt-24">
            <div className="flex items-start justify-between gap-4">
              <h2 id="aboutTitle" className="text-2xl font-extrabold tracking-tight" style={{ color: "var(--ink)" }}>
                Quiénes somos
              </h2>
              <button
                type="button"
                className="p-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50"
                onClick={() => setAboutOpen(false)}
              >
                ✕
              </button>
            </div>

            <div className="mt-4 space-y-5 text-slate-700 leading-relaxed">
              <p>
                <strong>Promequi nació en 1990</strong> con una misión urgente: cubrir la necesidad crítica de insumos
                médicos que muchos no podían entregar a tiempo. Donde otros fallaban, nosotros respondíamos con calidad,
                rapidez y compromiso.
              </p>
              <p>
                Desde entonces, hemos sido aliados confiables del sistema de salud guatemalteco, ofreciendo productos
                médicos y quirúrgicos de alta calidad a hospitales, clínicas y entidades públicas y privadas.{" "}
                <strong>Nuestra experiencia, de más de 30 años, habla por sí sola.</strong>
              </p>
              <p>
                Hoy, con presencia nacional y alianzas internacionales, mantenemos intacta nuestra esencia: servir con
                pasión, innovar constantemente y estar siempre al lado de quienes salvan vidas. Porque en Promequi,{" "}
                <strong>tu urgencia es nuestra prioridad.</strong>
              </p>
            </div>

            <div className="mt-6 flex justify-end">
              <button type="button" className="btn btn-brand" onClick={() => setAboutOpen(false)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
